'use client';

import dynamic from 'next/dynamic';
import { mockProperties } from '../data/mockProperties';
import type { Property, MapBounds } from '../types/property';

const MapBackground = dynamic(() => import('./MapBackground'), { ssr: false });

interface Props {
  properties?: Property[];
  selectedPropertyId?: string | null;
  onBoundsChange?: (bounds: MapBounds) => void;
  onSelectProperty?: (id: string) => void;
  center?: { lat: number; lng: number } | null;
}

export default function MapBackgroundClient({ properties = mockProperties, selectedPropertyId, onBoundsChange, onSelectProperty, center }: Props) {
  return <MapBackground properties={properties} selectedPropertyId={selectedPropertyId} onBoundsChange={onBoundsChange} onSelectProperty={onSelectProperty} center={center} />;
}
